<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="CPE供应商">
            <a-select
              v-decorator="['cpe_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="opt in supplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="CPE型号">
            <a-select
              v-decorator="['cpe_model_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingCpeModelOptions"
            >
              <a-select-option
                v-for="opt in cpeModelOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ formatModelOption(opt) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="通讯方式">
            <a-select
              v-decorator="['comm_mode_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingCommModeOptions"
            >
              <a-select-option
                v-for="opt in commModeOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="有效性">
            <a-select v-decorator="['effective']" allow-clear placeholder="全部">
              <a-select-option value="1">有效</a-select-option>
              <a-select-option value="0">无效</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findCpeSuppliers } from '@/api/cpe_supplier'
import { findCpeSupplierModelOptions } from '@/api/cpe_supplier_model'

export default {
  name: 'SearchBaseCpeProduct',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'base_cpe_product_search' }),
      supplierOptions: [],
      cpeModelOptions: [],
      commModeOptions: [],
      loadingSupplierOptions: false,
      loadingCpeModelOptions: false,
      loadingCommModeOptions: false
    }
  },
  created() {
    this.fetchSupplierOptions()
    this.fetchCpeModelOptions()
    this.fetchCommModeOptions()
  },
  methods: {
    formatModelOption(opt) {
      if (opt.display_model && opt.display_model !== opt.purchase_model) {
        return `${opt.purchase_model}（对外：${opt.display_model}）`
      }
      return opt.purchase_model || opt.name
    },

    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findCpeSuppliers({ per_page: 9999 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      })
    },

    fetchCpeModelOptions() {
      this.loadingCpeModelOptions = true
      findCpeSupplierModelOptions({}).then((res) => {
        if (res.code === 0) {
          this.cpeModelOptions = res.data
        }
        this.loadingCpeModelOptions = false
      })
    },

    fetchCommModeOptions() {
      this.loadingCommModeOptions = true
      findCommonTypeOptions('product_comm_mode').then((res) => {
        if (res.code === 0) {
          this.commModeOptions = res.data
        }
        this.loadingCommModeOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', values)
        }
      })
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
